import { BrowserRouter } from "react-router-dom";
import { CssBaseline, StyledEngineProvider } from "@mui/material";
import { ThemeProvider } from "@mui/material/styles";
import MainRoutes from "./routes";
import themes from "./themes";
import SnackBar from "./component/SnackBar";
import { useSelector } from "react-redux";
import { useDispatch } from "react-redux";
import { ShowSnackbar } from "./redux/action/ShowSnackbar";

const App = () => {
  const dispatch = useDispatch();
  const snackbarStateCommon = useSelector(
    (state) => state.snackbar.snackBarData
  );
  const handleCloseValidationCommon = () => {
    dispatch(ShowSnackbar({ open: false }));
  };

  return (
    <StyledEngineProvider injectFirst>
      <ThemeProvider
        theme={themes({ primaryColor: "#7F56D9", secondaryColor: "#6941C6" })}
      >
        <CssBaseline />
        <BrowserRouter>
          <MainRoutes />
        </BrowserRouter>
      </ThemeProvider>
      <SnackBar
        snackbarState={snackbarStateCommon}
        handleCloseValidation={handleCloseValidationCommon}
      />
    </StyledEngineProvider>
  );
};

export default App;
